class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.cancelOpenFocus?.();
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    let frame;
    const cancel = () => {
      cancelAnimationFrame(frame);
      clearTimeout(timer);
      this.removeEventListener('transitionend', onTransitionEnd);
      this.cancelOpenFocus = null;
    };
    const focusWhenVisible = () => {
      if (!this.isConnected || !this.classList.contains('active')) return cancel();
      const current = document.activeElement;
      this.focusContents(this.contains(current) ? current : undefined);
      if (this.contains(document.activeElement)) cancel();
    };
    const onTransitionEnd = (event) => {
      if (event.target === this || event.target === this.querySelector('.drawer__inner')) focusWhenVisible();
    };
    const timer = setTimeout(() => { focusWhenVisible(); cancel(); }, 400);
    this.cancelOpenFocus = cancel;
    this.addEventListener('transitionend', onTransitionEnd);
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(focusWhenVisible);
    });
  }

  focusContents(element) {
    const container = this.querySelector('.drawer__inner-empty') || this.querySelector('.drawer__inner');
    trapFocus(container, element || container.querySelector('.drawer__close'));
  }

  close() {
    this.cancelOpenFocus?.();
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.toggle('is-empty', this.getSectionDOM(parsedState.sections['cart-drawer'], 'cart-drawer').classList.contains('is-empty'));
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
    if (document.getElementById('main-cart-items')) {
      sections.push(...super.getSectionsToRender().filter((section) => section.section !== 'cart-drawer' && section.id !== 'cart-icon-bubble'));
    }
    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
